document.addEventListener('DOMContentLoaded', function() {
  const labels = document.querySelectorAll('.select-label.secondary_text');
  labels.forEach(label => {
    if(label.textContent.includes('Color:')) {
      label.innerHTML = label.innerHTML.replace('Color:', 'Renk:');
    }
    if(label.textContent.includes('Size:')) {
      label.innerHTML = label.innerHTML.replace('Size:', 'Beden:');
    }
  });
});
